
import { CouponType } from '../../enums';

export const setCouponTypeLabel = (couponType: CouponType): string => {
    switch (couponType) {
        case CouponType.STR: return 'Fixed rate';
        case CouponType.FRN: return 'Floating rate';
        case CouponType.CPZ: return 'Zero coupon';
    }
}